import styled from 'styled-components';
import TextField from '@mui/material/TextField';

import { ReactComponent as SearchRefractionIcon } from '../../assets/icons/search-refraction-icon.svg';
import colors from '../../styles/colors';

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const StyledTextField = styled(TextField)`
  margin: 10px;
  width: 100%;

  .MuiOutlinedInput-root {
    background-color: ${colors.base.alpha};
    border-radius: 5px;
    border: 1px solid ${colors.base.beta};

    &:hover {
      border: 1px solid ${colors.shades.secondary4};
      border-radius: 5px;
    }
    
    .MuiOutlinedInput-input {
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0;
      padding: 11px 4px;
      
      &::placeholder {
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0;
      }
    }
  }
`;

const StyledSearchRefractionIcon = styled(SearchRefractionIcon)`
  width: 20px;
  height: 16px;
  margin-right: 8px;
`;

export {
  Container,
  StyledTextField,
  StyledSearchRefractionIcon,
};
